import { render, staticRenderFns } from "./addRole.vue?vue&type=template&id=642a2afc&lang=pug&"
import script from "./addRole.vue?vue&type=script&lang=js&"
export * from "./addRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports